require('./bootstrap');

import Vue from 'vue';
import 'leaflet/dist/leaflet.css';
import { ZiggyVue } from 'ziggy';

Vue.use(ZiggyVue);
Vue.component('auto-complete-component', require('./components/Header/AutoCompleteComponent.vue').default);
Vue.component('map-component', require('./components/Map/Index.vue').default);
Vue.component('modal-categories-component', require('./components/Header/ModalCategoriesComponent.vue').default);
Vue.component('notifications-component', require('./components/Notification/Index.vue').default);
Vue.component('user-popin-component', require('./components/UserPopinComponent.vue').default);

let mixin = Vue.mixin({
    data() {
        return {}
    },

    methods: {
    },
});

Vue.component('add-address-component', require('./components/AddAddressComponent.vue').default);
Vue.component('book-details-component', require('./components/BookDetailsComponent.vue').default);
Vue.component('show-another-place-component', require('./components/ShowAnotherPlaceComponent.vue').default);
Vue.component('write-review-component', require('./components/WriteReviewComponent.vue').default);
Vue.component('show-phone-number-component', require('./components/ShowPhoneNumberComponent.vue').default);
Vue.component('signal-abuse-modal-component', require('./components/SignalAbuseModalComponent.vue').default);
Vue.component('vote-useful-component', require('./components/VoteUsefulComponent.vue').default);
Vue.component('edit-profile-component', require('./components/EditProfileComponent.vue').default);

const app = new Vue({
    mixins: [mixin],
    el: '#app',
});

var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})

// Custom Vanilla JS goes here
document.addEventListener('DOMContentLoaded', function () {
    let burger = document.querySelector('#burger');
    let closeMenuElements = document.querySelectorAll('.closeMenuElement')
    let lowResMenu = document.querySelector('#lowResMenu');
    let lowResMenuWrapper = document.querySelector('#lowResMenuWrapper');

    let openMenu = () => {
        burger.classList.add('open');
        lowResMenu.classList.add('show');
        document.body.style.height = window.getComputedStyle(lowResMenuWrapper).height;
        document.body.style.overflowY = 'hidden';
    }
    let closeMenu = () => {
        burger.classList.remove('open');
        lowResMenu.classList.remove('show');
        document.body.style.height = 'auto';
        document.body.style.overflowY = 'unset';
    }

    burger.addEventListener('click', () => {
        burger.classList.contains('open') ? closeMenu() : openMenu();
    })

    closeMenuElements.forEach(elt => {
        elt.addEventListener('click', () => {
            elt.classList.contains('show') ? closeMenu() : '';
        })
    })

    // Toggle options avancées
    const advancedOptionsButton = document.getElementById('advancedOptions');
    const advancedOptionsMenu = document.getElementById('advancedOptionsMenu');
    advancedOptionsButton.addEventListener('click', () => {
        advancedOptionsMenu.classList.toggle('hide');
        advancedOptionsMenu.classList.toggle('show');
    })

    // Tooltips
    const tooltipTriggers = document.querySelectorAll('.tooltipTrigger');
    if (tooltipTriggers !== null) {
        for (const tooltipTrigger of tooltipTriggers) {
            const index = tooltipTrigger.id.slice(14);
            const tooltip = document.getElementById(`tooltip${index}`);
            tooltipTrigger.addEventListener('mouseover', (event) => {
                tooltip.classList.remove('hide');
                tooltip.classList.add('showTooltip');
            })

            tooltipTrigger.addEventListener('mouseout', (event) => {
                tooltip.classList.add('hide');
                tooltip.classList.remove('showTooltip');
            })
        }
    }

    const modalCategories = document.querySelectorAll('.clickable-item');
    if (modalCategories !== null) {
        const searchCategoryInput = document.getElementById('what');

        for (const category of modalCategories) {
            category.addEventListener('click', (event) => {
                searchCategoryInput.value = event.target.textContent;
            })
        }
    }

    // LOGGED IN USER "MON JUSTACOTE" MENU
    const monJustacoteLink = document.querySelector('.mon-justacote-link');
    const monJustacoteMenu = document.querySelector('.mon-justacote-menu');
    const notificationIcon = document.querySelector('.notifications-icon');
    const notificationMenu = document.querySelector('.notifications-list');

    if (monJustacoteLink !== null) {
        monJustacoteLink.addEventListener('click', (event) => {
            event.preventDefault();
            monJustacoteMenu.classList.toggle('hide');

            if (notificationMenu.classList.value.includes('hide') === false) {
                notificationMenu.classList.add('hide');
            }
        })
    }

    const mapModal = document.getElementById('seeMap')
    if (mapModal) {
        const modal = bootstrap.Modal.getInstance(mapModal);
    }

    let linksHidden = document.querySelectorAll('.link-hidden');
    for (const link of linksHidden) {
        link.addEventListener('click', () => {
            document.location = '/redirection/' + link.getAttribute('data-value');

            return false;
        })
    }

    let checksUseful = document.querySelectorAll('.checkUseful');
    if(checksUseful.length) {
        checksUseful.forEach(useful => {
           useful.addEventListener('click', (e) => {
              e.preventDefault();
              let element = e.currentTarget;
               axios.post('/api/v1/vote/useful',
                   {
                       giverId: useful.getAttribute('data-giverId'),
                       modelId: useful.getAttribute('data-modelId'),
                       modelType: useful.getAttribute('data-modelType'),
                       profileId: useful.getAttribute('data-profileId'),
                       receiverId: useful.getAttribute('data-receiverId')
                   })
                   .then((response) => {
                       if(response.data.count > 0){
                           element.textContent = 'Utile (' + response.data.count + ')';
                       }
                   })
                   .catch((error) => {
                       console.log('Erreur ! ' + error);
                   })
           });
        });
    }

    // "stop-event" collapse
    const stopEventElements = document.getElementsByClassName('stop-event');

    Array.from(stopEventElements).forEach(element => {
        element.addEventListener('click', function(event) {
            event.stopPropagation(); // Arrêtez la propagation de l'événement
            window.location = event.currentTarget.href;
        });
    });

    let eyes = document.querySelectorAll('.eye');
    if (eyes.length) {
        eyes.forEach(eye => {
            eye.addEventListener('click', e => {
                e.preventDefault();
                let btn = e.currentTarget;
                let input = btn.closest('.input-group').querySelector('input');

                if (input && input.type === 'password') {
                    input.type = 'text';
                } else {
                    input.type = 'password';
                }

                let eyeClose = btn.querySelector('.eyeClose');
                eyeClose.classList.toggle('d-none');
                let eyeOpen = btn.querySelector('.eyeOpen');
                eyeOpen.classList.toggle('d-none');
            });
        });
    }
});

function linkHidden(hash) {
    return base64_decode(base64_decode(hash));
}

function base64_decode(data) {
    let b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        dec = "",
        tmp_arr = [];

    if (!data) {
        return data;
    }

    data += '';

    do {
        h1 = b64.indexOf(data.charAt(i++));
        h2 = b64.indexOf(data.charAt(i++));
        h3 = b64.indexOf(data.charAt(i++));
        h4 = b64.indexOf(data.charAt(i++));

        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

        o1 = bits >> 16 & 0xff;
        o2 = bits >> 8 & 0xff;
        o3 = bits & 0xff;

        if (h3 == 64) {
            tmp_arr[ac++] = String.fromCharCode(o1);
        } else if (h4 == 64) {
            tmp_arr[ac++] = String.fromCharCode(o1, o2);
        } else {
            tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
        }
    } while (i < data.length);

    dec = tmp_arr.join('');

    return dec;
}
